import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { SortArgs, SortDirection, SortOption } from "../../models/sort.model";

@Component({
    selector: 'sort-search-filter-header',
    templateUrl: './sort-search-filter-header.component.html',
    styleUrls: ['./sort-search-filter-header.component.scss'],
    standalone: false
})
export class SortSearchFilterHeaderComponent implements OnInit {

    @Input() enableFilter: boolean = false;
    @Input() enableSearch: boolean = false;
    @Input() enableSort: boolean = false;

    directions = SortDirection;
    mode: SortSearchFilterMode = SortSearchFilterMode.None;
    modes = SortSearchFilterMode;

   
    @Input() sortOptions: SortOption[] = [];
    @Input() title: string = "Header Title";

    @Output() onFilter: EventEmitter<string> = new EventEmitter<string>();
    @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();
    @Output() onSort: EventEmitter<SortArgs> = new EventEmitter<SortArgs>();   

    currentSortArgs: SortArgs = new SortArgs(SortDirection.None, "");
    defaultSort = { value: "", display: "No Sort" };
    filterText: string = "";
    searchTerm: string = "";
    selectedSort: string = "";
    sortItems: SortOption[] = [];
      
    constructor() { }

    ngOnInit() {
        for (let i = 0; i < this.sortOptions.length; i++) {
            let opt = this.sortOptions[i];
            this.sortItems.push(opt);
        }
        this.sortItems.unshift(this.defaultSort);
    }

    filter(): void {
        this.onFilter.emit(this.filterText);
    }

    resetFilter(): void {
        this.filterText = "";
        this.onFilter.emit(this.filterText);
    }

    resetSearch(): void {
        this.searchTerm = "";        
        this.onSearch.emit(this.searchTerm);
    }

    search(): void {
        if (this.searchTerm.length > 0) {
            this.onSearch.emit(this.searchTerm);
        }
    }

    setMode(modeOption: SortSearchFilterMode): void {
        this.mode = modeOption;
        switch (modeOption) {
            case SortSearchFilterMode.Sort:
                this.filterText = "";
                this.searchTerm = "";
                break;
            case SortSearchFilterMode.Search:
                this.filterText = "";
                this.currentSortArgs = new SortArgs(SortDirection.Ascending, "");
                break;
            case SortSearchFilterMode.Filter:
                this.searchTerm = "";
                this.currentSortArgs = new SortArgs(SortDirection.Ascending, "");
                break;
        }
    }

    setSortDirection(direction: SortDirection): void {
        if (!this.currentSortArgs) {
            this.currentSortArgs = new SortArgs(direction, this.selectedSort);
        } else {
            this.currentSortArgs.sortDirection = direction;
        }
        this.onSort.emit(this.currentSortArgs);
    }

    sortOptionChanged(property: string): void {
        if (!this.currentSortArgs) {
            this.currentSortArgs = new SortArgs(SortDirection.Ascending, property);
        } else {
            this.currentSortArgs.sortProperty = property;
        }
        this.onSort.emit(this.currentSortArgs);
    }

}

enum SortSearchFilterMode {
    None,
    Sort,
    Search,
    Filter
}


